import { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { FiChevronDown } from "react-icons/fi";

const AddTemplateModal = ({
  shown,
  templates = [],
  onClose,
  onAssignTemplate,
  onCreateTemplate,
}) => {
  const [selectedId, setSelectedId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  if (!shown) return null;

  const selectedTemplate = templates.find((t) => t.id === selectedId);

  return (
    <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="w-[436px] bg-white rounded-[6px] flex flex-col">
          <div className="border-b-[1px] border-borderColor py-3 px-4">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor">
              ADD TEMPLATE
            </p>
          </div>

          <div className="p-[18px]">
            <div className="w-full mb-4">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                Select a template
              </p>
              <OutsideClickHandler onOutsideClick={() => setDropdownOpen(false)}>
                <div className="relative w-full">
                  <div
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
                  >
                    <span className="font-OpenSansRegular text-[12px] truncate">
                      {selectedTemplate ? selectedTemplate.name : "Select"}
                    </span>
                    <FiChevronDown className="ml-2" size={15} />
                  </div>
                  {dropdownOpen && (
                    <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
                      {templates.length === 0 && (
                        <li className="px-4 py-2 font-OpenSansRegular text-[12px] text-subTitleColor">
                          No templates available
                        </li>
                      )}
                      {templates.map((tpl) => (
                        <li
                          key={tpl.id}
                          onClick={() => {
                            setSelectedId(tpl.id);
                            setDropdownOpen(false);
                          }}
                          className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
                        >
                          {tpl.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </OutsideClickHandler>
            </div>

            <div className="w-full mt-3">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onClose}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={() => {
                    if (selectedId) onAssignTemplate(selectedId);
                  }}
                  className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${selectedId
                      ? "bg-blueColor text-white cursor-pointer"
                      : "bg-gray-300 text-white cursor-not-allowed"
                    }`}
                >
                  ADD
                </div>
              </div>
              <div className="flex items-center justify-center mt-3">
                <span
                  onClick={onCreateTemplate}
                  className="text-[13px] font-OpenSansMedium text-blueColor cursor-pointer underline"
                >
                  Or create a new template
                </span>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AddTemplateModal;
